
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

interface NoDataViewProps {
  valueKey: string;
}

export function NoDataView({ valueKey }: NoDataViewProps) {
  const navigate = useNavigate();
  const metricType = valueKey === "displayHeight" ? "height" : "weight";
  
  return (
    <motion.div
      className="flex flex-col items-center justify-center h-[300px] text-center p-6 border border-dashed rounded-lg"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <p className="text-muted-foreground mb-4">No {metricType} data available for the selected time period.</p>
      <Button 
        onClick={() => navigate("/generate")}
        className="transition-all duration-300 hover:scale-105"
      >
        Record New Measurements
      </Button>
    </motion.div>
  );
}
